import { CHECKOUT_URL, PREVIEW_MODE } from "../data/siteConfig";

const PASSTHROUGH_KEYS = [
  "campaign_id",
  "adset_id",
  "ad_id",
  "campaign",
  "adset",
  "ad",
  "fbclid",
  "gclid",
  "wbraid",
  "gbraid",
  "src",
  "sck",
];

export function isPassthroughKey(key: string): boolean {
  const normalized = key.toLowerCase();
  return normalized.startsWith("utm_") || PASSTHROUGH_KEYS.includes(normalized);
}

/**
 * Appends incoming campaign / ad identifiers to the checkout URL.
 * Parameters already fixed on the checkout URL are never overwritten.
 */
export function buildCheckoutUrl(baseUrl: string, incomingSearch: string): string {
  const url = new URL(baseUrl);
  const fixedKeys = new Set(Array.from(url.searchParams.keys()));
  const incoming = new URLSearchParams(incomingSearch);
  const added = new Set<string>();

  incoming.forEach((value, key) => {
    if (!value || !isPassthroughKey(key)) return;
    if (fixedKeys.has(key) || added.has(key)) return;
    url.searchParams.set(key, value);
    added.add(key);
  });

  return url.toString();
}

/** Returns null while in preview mode — no checkout link is ever produced. */
export function getCheckoutHref(): string | null {
  if (PREVIEW_MODE) return null;
  const search = typeof window === "undefined" ? "" : window.location.search;
  return buildCheckoutUrl(CHECKOUT_URL, search);
}
